<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <section>
        <fieldset>
          <legend>
            {{ pageVocabs + "legend" | translate }}
          </legend>

          <div class="row">
            <!-- title -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.title"
                [control]="form?.get('title')"
                label="common.title"
              >
              </form-field>
            </div>

            <!-- postalCode -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="postalCode"
                [control]="form?.get('postalCode')"
                label="common.zipCode"
                [maxLength]="4"
                [minLength]="4"
              >
              </form-field>
            </div>

            <!-- state -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <zones-select-search
                class="tw-w-full"
                label="common.state"
                [control]="form?.get('province')"
                [id]="1"
                [removable]="formPageConfig.isEditMode ? false : true"
                (valueChange)="onChangeZones($event)"
                (onError)="onClose()"
              >
              </zones-select-search>
            </div>

            <!--city(zoneId) -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <zones-select-search
                class="tw-w-full"
                label="common.city"
                [control]="form?.get('city')"
                [id]="selectedState"
                [removable]="formPageConfig.isEditMode ? false : true"
                [value]="cityId"
                (valueChange)="cityId = $event; onCityChange($event)"
                (onError)="onClose()"
              >
              </zones-select-search>
            </div>

            <!--zoneId -->
            <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
              <zones-select-search
                class="tw-w-full"
                label="common.area"
                [control]="form?.get('zoneId')"
                [id]="cityId"
                [removable]="formPageConfig.isEditMode ? false : true"
                [(value)]="model.zoneId"
                (onError)="onClose()"
              >
              </zones-select-search>
            </div>
          </div>
        </fieldset>
      </section>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
